import type { CalendarDate } from '@internationalized/date';
import { parseDate } from '@internationalized/date';

type Tag<T> = { _tag: T };
export type CalendarDateString =
    | (string & Tag<'CalendarDateString'>)
    | Tag<'CalendarDateString'>;

export function createCalendarDateString(str: string): CalendarDateString {
    return str as CalendarDateString;
}

export function toCalendarDateString(date: CalendarDate): CalendarDateString {
    return createCalendarDateString(date.toString());
}

export function toCalendarDateStringOrNull(
    date: CalendarDate | null,
): CalendarDateString | null {
    return date === null ? null : toCalendarDateString(date);
}

export function fromCalendarDateString(string: CalendarDateString): CalendarDate {
    return parseDate(string as string);
}

export function fromCalendarDateStringOrNull(
    string: CalendarDateString | null,
): CalendarDate | null {
    return string === null ? null : fromCalendarDateString(string);
}
